import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface PageContainerProps {
  title: string;
  subtitle?: string;
  headerActions?: ReactNode;
  children: ReactNode;
  className?: string;
  maxWidth?: 'default' | 'wide' | 'full';
}

const maxWidthClasses = {
  default: 'container',
  wide: 'container max-w-7xl',
  full: 'w-full max-w-none px-6',
};

function renderTitle(title: string) {
  return <span className="text-foreground">{title}</span>;
}

export const PageContainer = ({
  title,
  subtitle,
  headerActions,
  children,
  className = '',
  maxWidth = 'default',
}: PageContainerProps) => {
  return (
    <div
      className={cn(
        'mx-auto space-y-6 px-6 py-6',
        maxWidthClasses[maxWidth],
        className
      )}
    >
      <div className="flex flex-col gap-4 border-b border-border pb-5 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h1 className="font-display text-3xl font-semibold tracking-tight">
            {renderTitle(title)}
          </h1>
          {subtitle && (
            <p className="mt-1.5 max-w-3xl text-sm text-muted-foreground">{subtitle}</p>
          )}
        </div>
        {headerActions && (
          <div className="flex items-center gap-2">{headerActions}</div>
        )}
      </div>

      {children}
    </div>
  );
};
